import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { Button } from "@/components/shared/buttons/Button";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import AddIcon from "@mui/icons-material/Add";
import { useMountEffect } from "@react-hookz/web";
import { useDialogs } from "@toolpad/core/useDialogs";
import { IndustriesTable } from "./components/IndustriesTable";
import { NewIndustryDialog } from "./components/dialogs/NewIndustryDialog";

const Industries = () => {
    const dialogs = useDialogs();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Industries");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Industries" },
        ]);
    });

    const handleNewIndustry = async () => {
        await dialogs.open(NewIndustryDialog);
    };

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Industries"
                subtitle="Manage industry classifications and associated risks"
            >
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    disableElevation
                    sx={{ borderRadius: 22 }}
                    startIcon={<AddIcon />}
                    onClick={handleNewIndustry}
                >
                    Create
                </Button>
            </AdminPageHeader>

            <div className="mt-6">
                <IndustriesTable />
            </div>
        </AdminPageContent>
    );
};

export default Industries;
